<ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
        <mat-spinner></mat-spinner>
    </div>
</ng-container>

<ng-template #pageContent>
    <h2 class="create-account text-start ms-4">My Classes</h2>
    <p class="ms-4 sub-heading">
        Manage your enrolled classrooms and courses
    </p>

    <div class="d-flex flex-wrap align-items-center justify-content-between gap-4 mt-4 mb-4 px-4">
        <div class="search-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input matInput placeholder="Search your classes here ..." [(ngModel)]="searchQuery"
                (ngModelChange)="onSearchQueryChange($event)" class="ms-2" />
        </div>

        <button class="responsive-btn" (click)="openJoinDialogBox()">
            <mat-icon>person_add</mat-icon>
            <span class="btn-text">Join Classroom</span>
        </button>
    </div>

    <div class="classroom-grid bg-color px-4">
        <ng-container *ngIf="_classroom.length > 0; else Result">
            <div *ngFor="let class of _classroom; let i = index" class="class-card"
                (click)="goToClassroomPage(class.id)">
                <div class="card-image-wrapper">
                    <img [src]="class.cover_image_url || 'assets/images/default-cover.jpg'" class="card-img-top"
                        alt="classroom" />
                    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                </div>
                <div class="card-content mt-1">
                    <div class="card-title d-flex align-items-center gap-1">
                        <img src="assets/images/book_ribbon.svg" alt="peoplelogo" class="class-logo" />
                        <span>{{ class.name || "N/A" }}</span>
                    </div>
                    <p class="card-subtitle text-start ms-0 mb-1">{{ class.subject || 'N/A' }}</p>
                    <div class="teacher-info d-flex align-items-center gap-1">
                        <img src="assets/images/people_classroom1.svg" alt="teacher-logo" class="teacher-logo" />
                        <span class="teacher-name">{{ class.teacher_name || 'N/A' }}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #Result>No classes found</ng-template>
    </div>
</ng-template>